import type { ValueOf } from "@/shared/types/helperTypes";

export const PLACE_LEVEL = {
    Continent: 1,
    CountryRegion: 2,
    Country: 3,
    StateRegion: 4,
    State: 5,
    CountyRegion: 6,
    County: 7,
    City: 8,
    Township: 9,
    PostalCode: 10,
} as const;

export type PlaceLevel = ValueOf<typeof PLACE_LEVEL>;

export interface SelectedPlace {
    Id: number | string;
    HName: string;
    LevelId: PlaceLevel;
    IdHierarchy: number[];
    UName?: string;
}

export type IdHierarchy = SelectedPlace["IdHierarchy"];
